import React, { useContext, useMemo } from 'react';

import {
  IClientBusinessModel,
  IClientAvenyModelType,
} from '../../Types/ClientModelTypes';
import { KodplanContext } from '../../Components/KodplanManager/Context/KodplanContext';
import { updateModelContext } from './UpdateModel/UpdateModel';
import clientAvenyModel from '../clientAvenyModel';
import { ActiveDatabaseContext } from '../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export type AvenyCollectionMap = Map<string, IClientBusinessModel>;

export interface IAvenyModelContext {
  avenyCollectionMap: AvenyCollectionMap;
}

const createCollectionMap = function createCollectionMap(
  model: IClientAvenyModelType
) {
  const result = new Map();
  Object.keys(model).forEach(code => {
    Object.keys(model[code].BusinessModels).forEach(collectionName => {
      result.set(
        collectionName.toLowerCase(),
        model[code].BusinessModels[collectionName]
      );
    });
  });
  return result;
};

export const collectionMap: Map<string, IClientBusinessModel> =
  createCollectionMap(clientAvenyModel);

export const ModelContext = React.createContext<IAvenyModelContext>({
  avenyCollectionMap: collectionMap,
});

export const ModelContextProvider = ModelContext.Provider;
export const ModelContextConsumer = ModelContext.Consumer;

interface IProps {}

const ModelProvider: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const activeKodplan = useContext(KodplanContext);
  const sessionInfo =
    activeDatabaseContext.activeDatabaseInfo?.me?.at(0)?.sessionInfo;
  const modelContext = useMemo(
    () =>
      updateModelContext(
        activeKodplan.activeKodplan,
        sessionInfo,
        collectionMap
      ),
    [activeKodplan.activeKodplan, sessionInfo]
  );

  return (
    <ModelContextProvider value={modelContext}>
      {props.children}
    </ModelContextProvider>
  );
};

export default ModelProvider;
